import PageHero from '@/components/feature/PageHero';

export default function DataAiHero() {
  return (
    <PageHero
      eyebrow="九畴云铺 · 数据与 AI"
      title="数据不是终点，而是下一次交易的起点"
      titleHighlight="数据飞轮 · TOMA AI"
      desc="九畴云铺的数据飞轮持续循环，TOMA AI 作为整个商业网络的智能层，为消费者、云社员、云店长、供应链与平台提供智能决策。"
      imageUrl="https://readdy.ai/api/search-image?query=Abstract%20data%20flywheel%20and%20AI%20intelligence%20layer%20visualization%2C%20deep%20dark%20ink%20navy%20background%2C%20glowing%20emerald%20and%20gold%20circular%20data%20flow%20with%20AI%20neural%20nodes%2C%20digital%20commerce%20intelligence%2C%20futuristic%20rural%20economy%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1800&height=1100&seq=jiuchou-ai-01&orientation=landscape"
      imageAlt="九畴云铺 数据飞轮与 TOMA AI"
      imageTitle="九畴云铺 数据飞轮与 AI"
    />
  );
}